import React, { useState } from "react";
import API from "../../ApiService/ApiService";
import Context from "./index";
// doctor provider

const DoctorProvider = (props) => {
  const api = new API();
  const [doctorData, setDoctorData] = useState("");
  const [doctorLoader, setDoctorLoader] = useState(false);

  const getDoctorData = async (doctorSlug) => {
    const url = "clinic/doctor_details";
    setDoctorLoader(true);
    await api.getAll(url, { slug: doctorSlug }, (err, res) => {
      if (res?.data?.status === 200) {
        console.log("Fetched Doctor Data:", res?.data?.data);
        const data = res?.data?.data;
        setDoctorData(data); // Store data in state
      } else {
        console.error("Error fetching data:", err);
      }
      setDoctorLoader(false);
    });
  };

  return (
    <Context.Provider
      value={{
        doctorData,
        setDoctorData,
        getDoctorData,
        doctorLoader,
        ...props,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default DoctorProvider;
